import { writable } from "svelte/store";

export const polls = writable();
